export enum ActionType {
  OPEN = 'modal/open',
  CLOSE = 'modal/close',
}

export type ModalID<T = unknown> = string & {
  readonly __brand: 'ModalID'
  readonly __result: T
}

export type Payload<T = any> = {
  submit: (result: T) => void
  args: any[]
}

export type Open = {
  type: ActionType.OPEN
  payload: Payload
  id: ModalID
}

export type Close = {
  type: ActionType.CLOSE
  id: ModalID
}

export type Action = Open | Close

export type State = Record<ModalID, Payload>
